/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ImportConnectionTagsOcppDefinition$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected ocpp configuration
 */
  ocppUid: string;
      body?: Blob
}

export function importConnectionTagsOcppDefinition(http: HttpClient, rootUrl: string, params: ImportConnectionTagsOcppDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, importConnectionTagsOcppDefinition.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('ocppUid', params.ocppUid, {});
    rb.body(params.body, 'application/vnd.ms-excel');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

importConnectionTagsOcppDefinition.PATH = '/stations/{uid}/ocpp/configuration/{ocppUid}/import';
